import { RMMMPairwiseRow } from '@Pages/GeoMMM/ScenarioPlanning/ScenarioPlanningLambdaUtils';
import { toFloat } from '@src/utils/data';

export const GX_TRACES_S3_KEYS = ['mmm/main/whatnot/GMV_Dollars/2026-05-21T16:24:44/gx_trace_0.nc'];

export interface PairwiseInteraction {
  primaryName: string;
  secondaryName: string | null;
  spendOrEffect: 'spend' | 'effect';
  categoryType: 'direct' | 'added' | 'reduced';
  mean: number;
  ciLo: number;
  ciHi: number;
}

/**
 * Extracts pairwise interaction data from rMMM pairwise rows,
 * joining mean/ci_lo/ci_hi estimate types by key.
 */
export const extractPairwiseData = (pairwiseRows: RMMMPairwiseRow[]): PairwiseInteraction[] => {
  const pairwiseKey = (r: RMMMPairwiseRow) =>
    `${r.primaryName}|${r.secondaryName}|${r.spendOrEffect}|${r.categoryType}`;
  const meanRows = pairwiseRows.filter(r => r.estimateType === 'mean');
  const ciLoMap = new Map(
    pairwiseRows
      .filter(r => r.estimateType === 'ci_lo')
      .map(r => [pairwiseKey(r), toFloat(r.value)])
  );
  const ciHiMap = new Map(
    pairwiseRows
      .filter(r => r.estimateType === 'ci_hi')
      .map(r => [pairwiseKey(r), toFloat(r.value)])
  );
  return meanRows.map(r => {
    const key = pairwiseKey(r);
    return {
      primaryName: r.primaryName,
      secondaryName: r.secondaryName,
      spendOrEffect: r.spendOrEffect,
      categoryType: r.categoryType,
      mean: toFloat(r.value),
      ciLo: ciLoMap.get(key) ?? 0,
      ciHi: ciHiMap.get(key) ?? 0
    };
  });
};
